import React from 'react';
import "./index.scss";
import i18n from 'i18next';
import { isRTL } from '../../../services/userModel.js';
import {getHelpLink} from "../../../help";
import IconButton from "../IconButton/index.js";

const SectionInfoTitle = ({ sectionModel, styles, infoTitleRef }) => {
  if(!sectionModel?.label) return null;

  const label = sectionModel.label;
  const translateInfoTitle = i18n.exists(label + '_INFO_TITLE') ? i18n.t(label + '_INFO_TITLE') : '';
  const translateInfoTitle2 = i18n.exists(label + '_INFO_TITLE_2') ? i18n.t(label + '_INFO_TITLE_2') : '';
  const translateInfoTitle3 = i18n.exists(label + '_INFO_TITLE_3') ? i18n.t(label + '_INFO_TITLE_3') : '';

  if(!translateInfoTitle) return null;

  const link = getHelpLink(label + '_INFO_LINK');
  const link2 = getHelpLink(label + '_INFO_LINK_2');
  const link3 = getHelpLink(label + '_INFO_LINK_3');

  const handleOnClick = (link) => {
    window.open(link, '_blank', 'noopener');
  }

  return (
    <div ref={infoTitleRef}>
      {[
        {text: translateInfoTitle, link: link},
        {text: translateInfoTitle2, link: link2},
        {text: translateInfoTitle3, link: link3}
      ].filter(item => !!item.text.length).map(item => (
        <div className="infoTitleWrapper" style={styles}>
          <IconButton iconName={'infoBook'} isIcon />
          <div className={"infoTitleContent"}>
            <div className="helpWrapper">
              <p style={{textAlign: isRTL() ? 'right' : ''}}>{item.text}</p>
              {!!item.link && (
                <div className="readMoreBlock">
                  <span className={'readMore'} onClick={() => handleOnClick(item.link)}>{i18n.t('basic.OPEN_GUIDE')}</span>
                  <IconButton iconName={'angleUp'} isIcon/>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SectionInfoTitle;